import Vue from 'vue'
import App from './App.vue'

import { Tab, Tabs } from 'vant';
import { Notify } from 'vant';
import { Popup } from 'vant';
import { Form } from 'vant';
import { Field } from 'vant';
import { Button } from 'vant';
import { Picker } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Progress } from 'vant';
import Api from './api'
import metaMask from './utils/metaMask'
import Message from './utils/message'
import store from './store'

Vue.prototype.$Message = Message
Vue.use(Api)
Vue.use(metaMask)

import { Swipe, SwipeItem } from 'vant';

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Progress);
import { Pagination } from 'vant';

Vue.use(Pagination);
import { Icon } from 'vant';

 
Vue.use(Icon);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Picker);

Vue.use(Button);

Vue.use(Form);
Vue.use(Field);

Vue.use(Popup);
Vue.use(Notify);
Vue.use(Tab);
Vue.use(Tabs);
import 'vant/lib/index.css';

import Router from 'vue-router'  //引入vue-router
import router from "./router/index.js" 

/* 复制 */
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


import wow from 'wowjs'
 
import 'wowjs/css/libs/animate.css'
 
Vue.prototype.$wow = wow


/*  */
import "./assets/css/common.css";
import "./assets/css/style.css";

/* 语言包 */
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);
// 多语言切换
const i18n = new VueI18n({
	locale: 'en', //设置默认语言
	messages:{
		'zh': require('./components/lang/cn'),
		'en': require('./components/lang/en')
	}
});


Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  store,
  router,
  i18n,   // 引用i18n
}).$mount('#app')
